/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileResponse } from "../models/ProfileResponse";
import type { ProfileUpdateRequest } from "../models/ProfileUpdateRequest";
import type { SignupAvailabilityResponse } from "../models/SignupAvailabilityResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class ProfileService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Signup Availability
   * 新規登録が可能かどうかを確認
   *
   * サインアップ画面表示前にUX目的で使用します。
   * 実際の上限チェックとカウントインクリメントはCognito Pre Sign-up Lambda Triggerで行います。
   * @returns SignupAvailabilityResponse Successful Response
   * @throws ApiError
   */
  public getSignupAvailability(): CancelablePromise<SignupAvailabilityResponse> {
    return this.httpRequest.request({
      method: "GET",
      url: "/signup/availability"
    });
  }

  /**
   * Get Profile
   * プロフィールを取得
   *
   * ユーザーが存在しない場合はデフォルト値を返します。
   * @returns ProfileResponse Successful Response
   * @throws ApiError
   */
  public getProfile({ userId }: { userId: string }): CancelablePromise<ProfileResponse> {
    return this.httpRequest.request({
      method: "GET",
      url: "/profile/{user_id}",
      path: {
        user_id: userId
      },
      errors: {
        422: `Validation Error`
      }
    });
  }

  /**
   * Update Profile
   * プロフィールを更新
   *
   * 初回登録時は利用規約・プラポリの同意バージョンも記録します。
   * pydanticのEnum型バリデーションにより、不正な値は自動的にエラーになります。
   * @returns ProfileResponse Successful Response
   * @throws ApiError
   */
  public updateProfile({
    userId,
    requestBody
  }: {
    userId: string;
    requestBody: ProfileUpdateRequest;
  }): CancelablePromise<ProfileResponse> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/profile/{user_id}",
      path: {
        user_id: userId
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`
      }
    });
  }
}
